export { BankSmallArticle } from './BankSmallArticle';
